// App.js (without useEffect)
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button, Input, Spin, Card } from 'antd';
import './App.css';

const App = () => {
  const colorData = {
    "taylorswift": "#adffc2",
    "fearless": "#f2db52",
    "fearlesstaylorsversion": "#f2db52",
    "speaknow": "plum",
    "speaknowtaylorsversion": "plum",
    "red": "#FF6666",
    "redtaylorsversion": "#FF6666",
    "soundsoftheseasonthetaylorswiftholidaycollection": "#FF6666",
    "1989": "lightblue",
    "reputation": "#818589",
    "lover": "lightpink",
    "folklore": "#D3D3D3",
    "evermore": "#C4A484",
    "midnights": "#acace6",
    "othersongs": "#013220"
  };
  
  const colorValuesArray = Object.values(colorData);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [searchResults, setSearchResults] = useState([]); // added searchResults state
  const [randomColor, setRandomColor] = useState(colorValuesArray[Math.floor(Math.random() * colorValuesArray.length)]); // added randomColor state

  // const endpoint = "http://localhost:1989";
  const endpoint = "https://api.botpowered.sg";
  // choose a random color from the colorValuesArray
  const handleSearch = async () => {
    setIsLoading(true);
    if (searchQuery.length < 3) {
      alert('Search requires at least 3 characters');
      setIsLoading(false);
      return;
    }
    // const req = await fetch(`https://api.botpowered.sg/swiftlyrics-match?q=${searchQuery}`);
    const req = await fetch(`${endpoint}/swiftlyrics-match?q=${searchQuery}`);
    const res = await req.json();
    // console.log(res);
    setSearchResults(res);
    setIsLoading(false);
    setShowResults(true);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const searchInputVariants = {
    hidden: { y: '100%' },
    visible: { y: 0 },
  };

  const searchButtonVariants = {
    hidden: { opacity: 1 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  };

  const searchResultsVariants = {
    hidden: { y: '100%', opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };


  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <div className="App">
      <p style={{
        fontWeight: "bold",
        fontSize: "1.5rem",
        marginBottom: "1rem",
        fontFamily: 'Axiforma',
        color: randomColor
      }}>swiftlyrics.kenif.xyz</p>
      <motion.div
        className="search-container"
        initial="hidden"
        animate="visible"
        variants={searchInputVariants}
      >
        <Input
          value={searchQuery}
          onChange={handleSearchChange}
          onPressEnter={handleSearch} // added onPressEnter event
          placeholder="Make the friendship bracelets"
          style={{
            borderColor: randomColor,
          }}
        />
        <motion.div
          className="search-button-container"
          initial="visible"
          animate={isLoading ? 'exit' : 'visible'}
          variants={searchButtonVariants}
          transition={{ duration: 0.2 }}
        >
          <Button type="primary" onClick={handleSearch} style={{
            backgroundColor: randomColor,
            borderColor: randomColor
          }}>
            Search
          </Button>
        </motion.div>
      </motion.div>

      {isLoading && (
        <div className="spinner-container">
          <Spin size="large" />
        </div>
      )}

      {showResults && (
        <motion.div
          className="search-results-container"
          initial="hidden"
          animate="visible"
          variants={searchResultsVariants}
        >
          <motion.div
            initial="hidden"
            animate="visible"
            variants={cardVariants}
            transition={{ duration: 1 }}
          >
            {
              searchResults.length > 0 ? (
                searchResults.map((result, index) => {
                  // if result.album_code is in colorData, use that color, else use white
                  const color = colorData[result.album_code] ? colorData[result.album_code] : "grey";
                  return (
                    <Card
                      key={index}
                      title={result.title}
                      headStyle={{ backgroundColor: color, color: "white", fontFamily: 'Axiforma' }}
                      bodyStyle={{ color: color, fontFamily: 'Axiforma' }}
                      extra={
                        <p style={{
                          color: "white",
                          // fontWeight: "bold",
                          fontSize: "0.7rem", fontFamily: 'Axiforma'
                        }}>From {result.album}</p>
                      }
                      style={{ width: '100%', borderColor: color, marginBottom: "1rem" }}
                    >
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>
                          <p style={{
                            fontWeight: "bold",
                            fontSize: "1.2rem",
                          }}>{result.matched_lyrics}</p>
                        </div>
                        <div style={{ width: "20%" }}>
                          <img
                            src={`${endpoint}/swiftlyrics-cover?album=${result.album_code}`}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                            style={{ width: "100%", height: "auto", borderRadius: "20px" }}
                          />
                        </div>
                      </div>
                    </Card>
                  );
                })
                
                ) : (
                <Card style={{ width: '100%' }}>
                  <p>No results found 😢</p>
                </Card>
              )
            }
          </motion.div>
        </motion.div>
        
      )}

      <p style={{
        fontSize: '0.6rem',
        color: randomColor,
      }}>Tweet & mention your screenshots <a href='https://twitter.com/casuallykenneth/' target='_blank' style={{
        color: randomColor,
      }}>@casuallykenneth</a></p>
    </div>
  );
};

export default App;
